import { render, staticRenderFns } from "./Pelatihan.vue?vue&type=template&id=3a1c9dc8"
import script from "./Pelatihan.vue?vue&type=script&lang=js"
export * from "./Pelatihan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports